//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blocktitleClass: {
      type: String,
      required: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      arrow: require("@/assets/image/icon/arrow.png")
    };
  },
  methods: {
    gotoMore() {
      if (this.item.jumpUrl) {
        let obj = {
          path: this.UTILS.splitUrl(this.item.jumpUrl),
          router: this.$router,
          query: {
            code: this.item.pageCode,
            title: this.item.pageName
          }
        };
        this.GLOBAL_.ccApp.openTo(obj);
      }
    }
  },
  mounted() {}
};



// WEBPACK FOOTER //
// ./src/components/block/components/header.vue